import { StyleSheet } from "aphrodite";

export interface IStyle {
  block: any;
}

export const MainBlockStyle: IStyle = StyleSheet.create({
  block: {
    boxSizing: "border-box",
  },
});
